import $ from 'jquery';
import _ from 'underscore';
import crud from './helpers/crud';
import Promise from 'bluebird';
import { getError, servletDelete, servletGet, servletGetAll } from './helpers';
import join from 'url-join';
import JSOG from 'jsog';

export default class ScrapeJobsDAO extends crud {

  constructor(urls) {
    super(urls.SCRAPE_JOBS_URL);
    this.SCRAPE_JOBS_URL = urls.SCRAPE_JOBS_URL;
  }

  unresolvedLocationNames(jobId) {
    if (typeof jobId !== 'string' || jobId.trim().length === 0) {
      return Promise.reject(new Error('Invalid job ID'));
    }
    return servletGet(join(this.SCRAPE_JOBS_URL, jobId, 'unresolved-location-tokens'))
      .then(({ results }) => results);
  }

  getSingle(id) {
    return servletGet(join(this.SCRAPE_JOBS_URL, id))
      .then(({ results }) => results);
  }

  deleteJob(id) {
    return servletDelete(this.SCRAPE_JOBS_URL, id);
  }

  action({ jobId, action }) {
    if (typeof jobId !== 'string') {
      return Promise.reject(new Error(`Invalid job id: ${jobId}`));
    }

    if (!_.contains([ 'save', 'process' ], action)) {
      return Promise.reject(new Error('Action must be one of "save" or "process"'));
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        method: 'POST',
        url: join(this.SCRAPE_JOBS_URL, jobId, action)
      }).then(
        (job) => resolve(JSOG.decode(job)),
        (jqXhr) => reject(getError(jqXhr, `Failed to ${action} job`))
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/util/dao/ScrapeJobsDAO.js